import { createLogger } from "redux-logger";
import createSagaMiddleware from "redux-saga";
import { rootReducer } from "../rootReducer";
import rootSaga from "../rootSaga";
import { configureStore } from "@reduxjs/toolkit";

const logger = createLogger();
const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({}).concat([sagaMiddleware, logger])
});

// const initialState = {};
// const middleware = [logger, sagaMiddleware];

// const composedEnhancers = composeWithDevTools(applyMiddleware(...middleware));

// const store = createStore(rootReducer, initialState, composedEnhancers);

sagaMiddleware.run(rootSaga);

export default store;
